import { CostCenterUserAssignTableDataDto } from '@interfaces/models';
import { Typography, ColumnDef } from '@ui/components';
import { Checkbox } from '@ui/components';
import { TFunction } from 'i18next';

export const getUsersColumns = (t: TFunction): ColumnDef<CostCenterUserAssignTableDataDto>[] => [
  {
    id: 'select',
    size: 40,
    maxSize: 40,
    header: ({ table }) => (
      <Checkbox
        onCheckedChange={(value) => table.toggleAllRowsSelected(!!value)}
        checked={table.getIsAllRowsSelected()}
      />
    ),
    cell: ({ row }) => {
      return (
        <Checkbox
          onCheckedChange={(value) => row.toggleSelected(!!value)}
          disabled={!row.getCanSelect()}
          checked={row.getIsSelected()}
          className="ml-0.5"
        />
      );
    },
  },
  {
    accessorKey: 'name',
    maxSize: 300,
    header: () => t('COST_CENTERS.USERS_ASSIGN_NAME'),
    cell: ({ row }) => (
      <Typography variant="labelMediumBook" element="span">
        {`${row.original.firstName} ${row.original.lastName}`}
      </Typography>
    ),
  },
  {
    accessorKey: 'email',
    maxSize: 300,
    header: () => t('COST_CENTERS.USERS_ASSIGN_EMAIL'),
    cell: ({ row }) => (
      <Typography variant="labelMediumBook" element="span">
        {row.original.email}
      </Typography>
    ),
  },
];
